import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IPositionRemarquableState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const positionRemarquableModule: Module<IPositionRemarquableState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default positionRemarquableModule
